import { Component, Input, OnInit } from '@angular/core';
import { VitalMetricsService } from './vital-metrics.service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Observable } from 'rxjs';
import { VitalMetricsTable } from './vital-metrics.interface';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-vital-metrics',
  template: `
    <div class="metric-card-holder">
      <app-vital-metrics-card
        [isEmpty]="isEmpty$ | async"
        [isError]="isError$ | async"
        [loading]="loading$ | async"
        (learnButtonClicked)="learnMore()"
        (refreshButtonClicked)="refreshScores()"
        [tableData]="tableData$ | async"
        [refreshing]="refreshing$ | async"
        [scoreAge]="scoreAge$ | async"
      ></app-vital-metrics-card>
    </div>
  `,
  styleUrls: ['./vital-metrics.component.scss'],
  standalone: false,
})
export class VitalMetricsComponent implements OnInit {
  @Input() domain: string;

  tableData$: Observable<VitalMetricsTable>;
  loading$: Observable<boolean>;
  isEmpty$: Observable<boolean>;
  isError$: Observable<boolean>;

  scoreAge$: Observable<number>;
  refreshing$: Observable<boolean>;

  constructor(
    private vitalMetricsService: VitalMetricsService,
    private snowplow: ProductAnalyticsService,
  ) {
    this.loading$ = vitalMetricsService.loading$;
    this.isError$ = vitalMetricsService.error$.pipe(map((err) => !!err));

    this.tableData$ = this.vitalMetricsService.vitalMetrics$;
    this.refreshing$ = this.vitalMetricsService.refreshing$;
  }

  ngOnInit(): void {
    this.isEmpty$ = this.tableData$.pipe(map((data) => !(!!data && !!data.records && data.records.length > 0)));
    this.scoreAge$ = this.vitalMetricsService.vitalMetrics$.pipe(
      map((table: VitalMetricsTable) => {
        return !!table && !!table.updateDate ? new Date().getTime() - new Date(table.updateDate).getTime() : 0;
      }),
    );
  }

  refreshScores(): void {
    this.vitalMetricsService.instantFetch(this.domain);
  }

  /**
   * Takes users to web dev doc on why improving PageSpeed is important in a different tab.
   */
  public learnMore(): void {
    const url = `https://web.dev/vitals/`;
    window.open(url, '_blank');
  }
}
